export const readPreference = (key: string): string | null => {
  try { return localStorage.getItem(key); } catch { return null; }
};
export const writePreference = (key: string, value: string): void => {
  try { localStorage.setItem(key, value); } catch { /* Keep the page usable when browser storage is restricted. */ }
};
export const removePreference = (key: string): void => {
  try { localStorage.removeItem(key); } catch { /* Preferences are best-effort; conversation failures are surfaced separately. */ }
};
